export default function ContactCTA() {
  return (
    <section className="relative bg-forest-800 py-24 md:py-28 overflow-hidden">
      {/* Background texture overlay */}
      <div className="absolute inset-0">
        <img
          src="/images/cta.jpeg"
          alt=""
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-forest-800/70" />
      </div>

      {/* Decorative circles */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full border border-cream-200/5 pointer-events-none" />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full border border-cream-200/5 pointer-events-none" />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 rounded-full border border-cream-200/8 pointer-events-none" />

      <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="w-12 h-px bg-cream-400/40" />
          <span className="text-cream-400/60 text-xs font-serif tracking-widest2">CONTACT</span>
          <div className="w-12 h-px bg-cream-400/40" />
        </div>

        <h2 className="text-cream-100 font-serif font-light text-3xl md:text-4xl tracking-widest leading-snug mb-4">
          お気軽にご連絡ください
        </h2>

        <p className="text-cream-400/70 text-sm font-serif leading-relaxed mb-2">
          OMFES事務局
        </p>
        <p className="text-cream-400/60 text-xs font-serif tracking-wider mb-10">
          東京都千代田区神田須田町一丁目十六ー五 ヒューリック神田ビル７階
        </p>

        <a
          href="mailto:omfes.info@gmail.com"
          className="inline-flex items-center gap-3 px-8 py-4 bg-cream-200 text-forest-800 text-sm font-serif tracking-widest hover:bg-cream-100 transition-colors duration-200 rounded-sm whitespace-nowrap cursor-pointer"
        >
          <div className="w-8 h-8 flex items-center justify-center bg-forest-700 rounded-sm flex-shrink-0">
            <i className="ri-mail-line text-cream-300 text-sm" />
          </div>
          omfes.info@gmail.com にメールする
        </a>
      </div>
    </section>
  );
}
